<div
  class="card-buttons"
  [ngClass]="{
    'size-small': sizeSmall,
  }"
>
  <ion-button
    class="card-buttons--grow"
    [size]="size"
    color="success"
    fill="solid"
    [disabled]="isOffline()"
    libClickStopPropagation
    (click)="showAlertAcceptPrice()"
  >
    <ion-icon
      src="../assets/material-symbols/task_alt_24dp.svg"
      slot="start"
    ></ion-icon>
    @if (sizeSmall) {
      Aceptar
    } @else {
      Aceptar precio
    }
  </ion-button>
  <ion-button
    class="card-buttons--min"
    shape="round"
    [size]="size"
    color="danger"
    fill="outline"
    [disabled]="isOffline()"
    libClickStopPropagation
    (click)="showAlertRejectPrice()"
  >
    <ion-icon
      src="../assets/material-symbols/close_24dp.svg"
      [slot]="sizeSmall ? 'icon-only' : 'start'"
    ></ion-icon>
    @if (!sizeSmall) {
      Rechazar
    }
  </ion-button>
</div>
